import { mapActions, mapState } from 'vuex';
import bridge from '@utiles/bridge';
import { MAIN_HOST } from '@store/ultile';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import globalConfig from '@utiles/globalConfig';
const isH5 = globalConfig.getHrefParam('h5') === '1';
const IS_REVIEW = parseInt(globalConfig.getHrefParam('CacheToken'), 10) || 0;
const IS_IOS = globalConfig.getHrefParam('devicePlate') == 'ios';
export default {
  props: {
    gameId: {
      type: String,
      default: ''
    },
    submitForm: {
      type: Object,
      default: () => ({})
    },
    isInPassport: {
      type: Boolean,
      default: false
    },
    step: {
      type: String
    }
  },
  emits: [
    'nextStep',
    'prevStep',
    'updateGameId',
    'updateSubmitForm',
    'setOverlayVisible',
    'deleteCustomSkin'
  ],
  computed: {
    ...mapState({
      languages: state => state.languages,
      curLang: state => state.curLang,
      urlParams: state => state.urlParams,
      loginAccount: state => state.loginAccount
    }),
    isCoolingOff() {
      return this.submitForm.isNeedCooling;
    },
    isSumPay() {
      return this.submitForm.isSumPay;
    },
    mainColor() {
      return (
        getComputedStyle(document.documentElement)
          .getPropertyValue('--main-color')
          .trim() || '#000000'
      );
    },
    isIosReview() {
      return IS_IOS && IS_REVIEW;
    }
  },
  methods: {
    ...mapActions(['submitAiOrder', 'getIsIpKrOrJp', 'logout']),
    nextStep() {
      this.$emit('nextStep', this.compKey);
    },
    prevStep() {
      this.$emit('prevStep', this.compKey);
    },
    contactService() {
      this.$router.push({
        path: '/creatework',
        query: {
          source: 'deleteAccount'
        }
      });
    },
    updateGameId(gameId) {
      this.$emit('updateGameId', gameId);
    },
    updateSubmitForm(data) {
      this.$emit('updateSubmitForm', data);
    },
    getSubmitCommonParams() {
      return {
        game_id: this.gameId,
        id: this.submitForm.id,
        appLanguage: this.curLang,
        language: this.curLang,
        source_type: 2
      };
    },
    jumpServiceHome() {
      this.$emit('deleteCustomSkin');
      this.$router.push({
        path: '/workhome',
        query: {
          source: 'deleteAccountAgreeTerms'
        }
      });
    },
    jumpOrderList() {
      this.$router.push({
        path: '/mylist',
        query: {
          source: 'deleteAccountFomInput'
        }
      });
    },
    jumpOrderDetail(workId) {
      this.$router.push({
        name: 'mywork',
        params: { workId },
        query: {
          source: 'deleteAccountFomInput'
        }
      });
    },
    jumpRecoveryPage() {
      const link = getGlobalGetGotoLink({
        link: `https://service.${MAIN_HOST}/platform/support.html?gameId=${this.gameId}#/account`
      });
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('openBrowser', {
          url: link,
          loginDir: 1,
          appendParams: 1
        });
        setTimeout(() => {
          this.handleLogout();
        }, 1000);
        return;
      }
      window.open(link, '_blank');
      setTimeout(() => {
        this.handleLogout();
      }, 300);
    },
    async handleLogout() {
      if (isH5) {
        window.parent.postMessage(
          {
            method: 'logout'
          },
          window.location.origin
        );
        return;
      }
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('logout', {});
        return;
      }
      await this.logout({ language: this.curLang });
      this.jumpServiceHome();
    },
    jumpPolicy() {
      let link = `//gpassport.${MAIN_HOST}/center/${
        this.submitForm.isJp ? 'Jp' : ''
      }ServicePrivacy/customize?keyWord=deleteaccount_`;
      if (['ja-JP', 'ko-KR', 'zh-TW'].includes(this.curLang)) {
        link = `${link}${this.curLang.split('-')[1].toLowerCase()}`;
      } else if (['th-TH', 'vi-VN'].includes(this.curLang)) {
        link = `${link}th`;
      } else {
        link = `${link}en`;
      }
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('openBrowser', {
          url: link,
          loginDir: 1,
          appendParams: 1
        });
        return;
      }
      window.open(link, '_blank');
    },
    setOverlayVisible(visible) {
      this.$emit('setOverlayVisible', visible);
    }
  }
};
